import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronDown = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.5 8L12 16.5L20.5 8", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronDown.js.map